import { render, staticRenderFns } from "./invited.vue?vue&type=template&id=2ad622e6&scoped=true"
import script from "./invited.vue?vue&type=script&lang=js"
export * from "./invited.vue?vue&type=script&lang=js"
import style0 from "./invited.vue?vue&type=style&index=0&id=2ad622e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad622e6",
  null
  
)

export default component.exports